<template>
    <div class="search">
        <div style="margin-top:2%;margin-left:30%;margin-right:30% ">
            <!-- <el-input placeholder="请输入内容" v-model="input" class="input-with-select">
                <el-select v-model="select" slot="prepend" placeholder="请选择">
                  <el-option label="商品名称" value="1"></el-option>
                  <el-option label="品牌名称" value="2"></el-option>
                  <el-option label="商品属性" value="3"></el-option>
                  <el-option label="所有商品" value="4"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input> -->
            <el-autocomplete placeholder="请输入内容" v-model="input"  :fetch-suggestions="querySearchAsync" @select="handleSelect">
                <el-select v-model="select" slot="prepend" placeholder="请选择">
                  <el-option label="商品名称" value="1"></el-option>
                  <el-option label="品牌名称" value="2"></el-option>
                  <el-option label="商品属性" value="3"></el-option>
                  <el-option label="所有商品" value="4"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-autocomplete>
            <el-button type="primary" size="medium" style="margin-left:10%;" @click="downExcle">导出全部商品</el-button>
            <!-- <el-input placeholder="请输入内容" v-model="input" class="input-with-select" >
                <el-select v-model="select" slot="prepend" placeholder="请选择">
                  <el-option label="商品名称" value="1"></el-option>
                  <el-option label="品牌名称" value="2"></el-option>
                  <el-option label="商品属性" value="3"></el-option>
                  <el-option label="所有商品" value="4"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input> -->
        </div>
        <div style="margin-top:2%;margin-left:50%;" >
          <el-select v-model='time' placeholder="选择直播场次"  >
              <el-option
                v-for="item in menuInfo"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </div>

        <div style="margin-top:2%;margin-left:5%;margin-right:5% ">
          <el-card shadow="always">
              <el-table
                :max-height="tableHeight"
                :data="searchResult.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) ||data.properties.toLowerCase().includes(tableSearch.toLowerCase()) )"
                style="width: 100%"
                :empty-text="loadInfo">

                <el-table-column
                  label="序号"
                  type="index"
                  width=80px>
                </el-table-column>

                <!-- <el-table-column
                  label="商品 ID"
                  prop="id"
                  width="auto"
                  min-width="10%">
                </el-table-column> -->

                <el-table-column
                  label="品牌名称"
                  prop="brand"
                  width="auto"
                  sortable
                  min-width="20%">
                </el-table-column>

                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="品牌名称" v-if="props.row.brand">
                        <span>{{ props.row.brand }}</span>
                      </el-form-item>
                      <el-form-item label="商品名称" v-if="props.row.name">
                        <span>{{ props.row.name }}</span>
                      </el-form-item>
                      <el-form-item label="所属店铺" v-if="props.row.shop">
                        <span>{{ props.row.shop }}</span>
                      </el-form-item>
                      <el-form-item label="商品属性" v-if="props.row.properties">
                        <span>{{ props.row.properties }}</span>
                      </el-form-item>
                      <el-form-item label="商品规格" v-if="props.row.specs">
                        <span>{{ props.row.specs }}</span>
                      </el-form-item>
                      <el-form-item label="商品位置" v-if="props.row.location">
                        <span>{{ props.row.location }}</span>
                      </el-form-item>
                      <el-form-item label="直播价" v-if="props.row.lowPrice">
                        <span>{{ props.row.lowPrice }}</span>
                      </el-form-item>
                      <el-form-item label="商品已拥有" v-if="props.row.hasString">
                        <span>{{ props.row.hasString }}</span>
                      </el-form-item>
                      <el-form-item label="商品描述" v-if="props.row.description">
                        <span>{{ props.row.description }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  width="auto"
                  min-width="35%"
                  sortable
                  prop="name">
                </el-table-column>
                <el-table-column
                  label="属性"
                  prop="properties"
                  sortable
                  min-width="20%">
                </el-table-column>
                <el-table-column
                  label="状态"
                  prop="state"
                  sortable
                  min-width="20%">
                </el-table-column>
                <el-table-column width="auto"  min-width="25%">
                  <template slot="header" slot-scope="scope">
                    <el-input
                      v-model="tableSearch"
                      size="mini"
                      placeholder="输入关键字搜索"/>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleSee(scope.$index, scope.row)">查看</el-button>
                    <el-button
                      size="mini"
                      type="success"
                      @click="handleUpdate(scope.$index, scope.row)">修改</el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="handlBeforeAddToLive(scope.row)">加入直播</el-button>
                    <!-- <el-button
                      size="mini"
                      type="primary"
                      @click="handlBeforeAddToInventory(scope.row)">加入盘货</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
        </div>
    </div>
</template>

<style>
  .el-select .el-input {
    width: 130px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>
<script>
import Common from './Common'
export default {
  name: 'Search',
  data () {
    return {
      timeout: null,
      input: '',
      select: '2',
      timeId: '',
      searchResult: [],
      time: '',
      tableSearch: '',
      menuInfo: [],
      tableHeight: window.innerHeight * 0.6,
      loadInfo: '暂无数据'
    }
  },
  mounted () {
    this.getAllLives()
  },
  methods: {
    handleSelect (item) {
      console.log(item)
    },
    querySearchAsync (queryString, cb) {
      console.log(queryString)
      var results = []
      // eslint-disable-next-line eqeqeq
      // if (this.input == queryString) {
      //   console.log(456)
      //   cb(results)
      //   return
      // }
      this.input = queryString
      this.$axios.get(Common.baseUrl + 'goods/searchSuggestion', {params: {input: this.input, type: this.select}}
      ).then((res) => {
        let code = res.data.code
        console.log(res.data)
        if (code === 200) {
          if (res.data.data != null) {
            res.data.data.forEach(item => {
              results.push({'value': item})
            })
          }
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            cb(results)
          }, 500)
        } else if (code === 401) {
          this.loadInfo = '暂无数据'
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.loadInfo = '暂无数据'
          // this.$message({
          //   message: res.data.msg,
          //   type: 'warning'
          // })
        }
      }).catch(error => {
        this.loadInfo = '暂无数据'
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    search () {
      this.searchResult = []
      if (this.select === '1') {
        this.loadInfo = '数据加载中'
        this.$axios.get(Common.baseUrl + 'goods/searchByName', {params: {input: this.input}}
        ).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.loadInfo = '暂无数据'
            this.searchResult = res.data.data
            for (let i in this.searchResult) {
              let hasList = this.searchResult[i].has
              this.searchResult[i].hasString = hasList.join(' · ')
            }
          } else if (code === 401) {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.$router.push('/login')
          } else {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch(error => {
          this.loadInfo = '暂无数据'
          this.$message({
            message: error,
            type: 'warning'
          })
        })
      } else if (this.select === '2') {
        this.loadInfo = '数据加载中'
        this.$axios.get(Common.baseUrl + 'goods/searchByBrandName', {params: {input: this.input}}
        ).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.loadInfo = '暂无数据'
            this.searchResult = res.data.data
            for (let i in this.searchResult) {
              let hasList = this.searchResult[i].has
              this.searchResult[i].hasString = hasList.join(' · ')
            }
          } else if (code === 401) {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.$router.push('/login')
          } else {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch(error => {
          this.loadInfo = '暂无数据'
          console.log(error)
        })
      } else if (this.select === '3') {
        this.loadInfo = '数据加载中'
        this.$axios.get(Common.baseUrl + 'goods/searchByProperty', {params: {input: this.input}}
        ).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.loadInfo = '暂无数据'
            this.searchResult = res.data.data
            for (let i in this.searchResult) {
              let hasList = this.searchResult[i].has
              this.searchResult[i].hasString = hasList.join(' · ')
            }
          } else if (code === 401) {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.$router.push('/login')
          } else {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch(error => {
          this.loadInfo = '暂无数据'
          console.log(error)
        })
      } else if (this.select === '4') {
        this.loadInfo = '数据加载中'
        this.$axios.get(Common.baseUrl + 'goods/getAllGoods'
        ).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.loadInfo = '暂无数据'
            this.searchResult = res.data.data
            for (let i in this.searchResult) {
              let hasList = this.searchResult[i].has
              this.searchResult[i].hasString = hasList.join(' · ')
            }
          } else if (code === 401) {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.$router.push('/login')
          } else {
            this.loadInfo = '暂无数据'
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch(error => {
          this.loadInfo = '暂无数据'
          console.log(error)
        })
      }
    },
    getAllLives () {
      this.$axios.get(Common.baseUrl + 'lives/getAllLives'
      ).then((res) => {
        let code = res.data.code
        this.menuInfo = []
        if (code === 200) {
          for (var i in res.data.data) {
            let s = res.data.data[i].time
            let time = s.substring(0, s.indexOf(' '))
            let live = {value: res.data.data[i].id, label: time}
            this.menuInfo.push(live)
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleSee (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/show',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleUpdate (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/update',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleAddToLive (row) {
      let itemId = row.id
      let timeId = this.time
      let data = {goodsId: itemId, liveId: timeId}
      this.$axios.post(Common.baseUrl + 'liveHasGoods/addToLive', data
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '加入直播成功！',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handlBeforeAddToLive (row) {
      let timeId = this.time
      if (timeId === '') {
        this.$message({
          message: '请选择直播场次！',
          type: 'warning'
        })
        return
      }
      let selectLiveTime = ''
      for (var i in this.menuInfo) {
        if (this.menuInfo[i].value === timeId) {
          selectLiveTime = this.menuInfo[i].label
        }
      }
      this.$confirm('是否加入' + selectLiveTime + '直播?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleAddToLive(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    downExcle () {
      this.$axios({
        responseType: 'blob',
        method: 'post',
        url: Common.baseUrl + 'goods/downLoadAllGoods'
      }).then((res) => {
        let code = res.status
        if (code === 200) {
          const { data, headers } = res
          const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
          // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
          const blob = new Blob([data], {type: headers['content-type']})
          let dom = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          dom.href = url
          dom.download = decodeURI(fileName)
          dom.style.display = 'none'
          document.body.appendChild(dom)
          dom.click()
          dom.parentNode.removeChild(dom)
          window.URL.revokeObjectURL(url)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue